import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import "./HomeServices.css";

const particlesInit = async (main) => {
  await loadFull(main);
};

const HomeServices = () => {
  const { t } = useTranslation();

  const services = t("HomeServices.Services", { returnObjects: true });

  return (
    <section className="home-services">
      <div className="services-container">
        <Particles
          id="services-particles"
          init={particlesInit}
          options={{
            fullScreen: false,
            background: { color: { value: "transparent" } },
            particles: {
              number: { value: 25, density: { enable: true, area: 800 } },
              color: { value: "#00aaff" },
              shape: { type: "circle" },
              opacity: { value: 0.4 },
              size: { value: 3 },
              move: {
                enable: true,
                speed: 1.5,
                direction: "none",
                outMode: "out",
              },
            },
          }}
        />

        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          {t("HomeServices.Title")}
        </motion.h2>

        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              className="service-card"
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeServices;